import React from 'react';
import PropTypes from 'prop-types';

import Header from '../copied/Header';
import HeaderTitle from '../copied/HeaderTitle';
import HeaderIcon from '../copied/HeaderIcon';
import CloseIcon from '../copied/CloseIcon';
import MidIcon from '../elements/MidIcon';
import FullIcon from '../elements/FullIcon';
import MinimizeIcon from '../elements/MinimizeIcon';

import '../../styles.css';

CustomHeader.propTypes = {
  headerTitle: PropTypes.string,
  floating: PropTypes.bool,
  expand: PropTypes.oneOf(['default','mid','full']),
  toggleChatBot: PropTypes.func,
  toggleMode: PropTypes.func,
};

function CustomHeader({headerTitle,floating,expand,toggleChatBot,toggleMode}) {

  function handleClose() {
    toggleChatBot(false);
  }

  return (
    <Header className="rsc-header">
      <HeaderTitle className="rsc-header-title">{headerTitle}</HeaderTitle>
      <div className="rsc-header-icons">
        <HeaderIcon className={'rsc-header-expand-'+expand+'-button'} onClick={toggleMode}>
          {expand === 'default' ? <MidIcon /> : (expand === 'mid' ? <FullIcon /> : <MinimizeIcon />)}
        </HeaderIcon>
        {floating && (
          <HeaderIcon className="rsc-header-close-button" onClick={handleClose}>
            <CloseIcon />
          </HeaderIcon>
        )}
      </div>
    </Header>
  );
}

export default CustomHeader;